import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus, DollarSign } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import SingleSelect from "../../SingleSelect/SingleSelect";
import qr from '../../../assets/images/qr.jpeg';
import { Container, Row, Col, Card, CardBody, CardHeader, Badge, Modal,
  ModalBody,
  ModalFooter,
  ModalHeader, Label, Input } from "reactstrap";
import { Btn, H5, Spinner, Image } from "../../../AbstractElements";
import axios from "axios";
import Basic from '../../../_core/Ui-kits/Tooltip/Basic2';
import Dropzone1 from "../../Bonus UI/Dropzones/Dropzone1";

const user_options = ["Name", "Province", "District", "Status"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t,
}) => (
  <div style={{ display: "flex", flexDirection: "row", width: 'auto', gap: 10 }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
    {userOption === 'Status' ?
      <SingleSelect
        options={["Submitted", "Send For Edits", "Accepted", "Rejected", "Uploaded"]}
        selectedOption={filterText}
        onChange={(e) => onFilter({ target: { value: e } })}
      />
      : <>
         <input
            className="form-control"
            placeholder={userOption === 'District'? t("Filter by District") : userOption === 'Name'? t("Filter by Name") : userOption === 'Province'? t("Filter by Province") : t("Filter by Status") }
            aria-label="Search Input"
            style={{ width: "250px", paddingLeft: "5px" }}
            name="phone"
            id="search"
            type="text"
            value={filterText}
            onChange={onFilter}
          />
          <Btn attrBtn={{ onClick: onClear }} type="button">
            X
          </Btn>
        </>
    }
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Name");
  const [proReq, setProReq] = useState(false);
  const [proReqFees, setProReqFees] = useState(0);
  const [filteredItems, setFilteredItems] = useState();
  const [currentRenew, setCurrentRenew] = useState(0);
  const [currentNew, setCurrentNew] = useState(0);

  const [titleOption, setSelectedTitleOption] = useState([
    {
      value: "(FY-82/83)",
      label: "(FY-82/83)",
    },
  ]);

  const [currentAGM, setCurrentAGM] = useState(0);
  const [noOfYears, setNoOfYears] = useState(1);
  const [currentFirm, setCurrentFirm] = useState(0);
  const [currentRow, setCurrentRow] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const [file, setFile] = useState();
  const [file2, setFile2] = useState();
  /*const toggle = (id) => {
    setCurrentFirm(id);
    setModal(!modal);
  };*/


  const titles = [
    { value: "(FY-82/83)", label: "(FY-82/83)" },
    { value: "(FY-83/84)", label: "(FY-83/84)" },
    { value: "(FY-84/85)", label: "(FY-84/85)" },
    { value: "(FY-85/86)", label: "(FY-85/86)" },
    { value: "(FY-86/87)", label: "(FY-86/87)" },
  ];


  const toggle = useCallback((id, row) => {
    if(row?.district !== "Kathmandu" ||
      row?.district !==   "Bhaktapur" ||
      row?.district !==  "Lalitpur"
    ) {
      setProReq(true);
      if(row?.province ===  "Bagmati Province" && (row?.district === "Hetauda" || row?.district === "Chitwan")) {
        if(row?.district === "Hetauda") {
          setProReqFees(2100);
        } else {
          setProReqFees(5000);
        }
      } else if(row?.province ===  "Province No. 1") {
        setProReqFees(2400);
      }else if(row?.province ===  "Province No. 2") {
        setProReqFees(2500);
      }else if(row?.province ===  "Gandaki Province") {
        setProReqFees(7000);
      }else if(row?.province ===  "Lumbini Province") {
        setProReqFees(5106);
      }else if(row?.province ===  "Karnali Province") {
        setProReqFees(1100);
      }else {
        setProReqFees(0);
      }
    }
    setCurrentFirm(id);
    setCurrentRow(row);
    setModal((prev) => !prev);

  }, []);

  const { t } = useTranslation();
  useEffect(() => {
    handle_get_firms();
    handle_get_dates();

  }, []);

  useEffect(() => {

  }, [])

  const getUploadParams3 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus3 = ({ meta, file }, status) => {
    setFile(file);
  };


  const getUploadParams4 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus4 = ({ meta, file }, status) => {
    setFile2(file);
  };

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/firms", {
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setData(response2?.data?.data?.firms);
        setFilteredItems(response2?.data?.data?.firms);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };


  const handle_get_dates = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/proxies/proxy/dates", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setCurrentRenew(response2?.data?.data?.dates?.[0]?.renew);
        setCurrentNew(response2?.data?.data?.dates?.[0]?.new_mem);
        setCurrentAGM(response2?.data?.data?.dates?.[0]?.current_agm);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };

  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete:\r ${selectedRows.map((r) => r.name)}?`
      )
    ) {
      setToggleCleared(!toggleCleared);
      setData(differenceBy(data, selectedRows, "name"));
      toast.success("Successfully Deleted !");
    }
  };

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
          ? data?.filter((item) =>
              item?.name_of_firm
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
          : userOption === "Province"
          ? data?.filter((item) =>
              item?.province?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "District"
          ? data?.filter((item) =>
              item?.district?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : data?.filter((item) =>
            String(item?.status === 1? 'Submitted' : item?.status === 2?  'Send For Edits' : item?.status === 3?  'Accepted' : item?.status === 4?  'Rejected' : item?.status === 10?  'Uploaded' : 'Send For Edits')?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle, userOption]);


    const ComponentEdit = useCallback((row) => {
      return (
        <span style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/firm/edit', { state: { id: row?.id } })}>
            <Edit />
          </div>
          {(row?.membership_status !== 2 || row?.membership_status_new !== 2 || row?.agm_status !== 2 || (row?.province_status !== 2)) &&
            <div style={{ cursor: 'pointer' }} onClick={() => toggle(row?.id, row)}>
              <DollarSign />
            </div>
          }
        </span>
      );
    }, [navigate, toggle]);

  const handleAddNewClick = () => {
    navigate('/firm/add');
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <Badge color="primary">Submitted</Badge>;
      case 2:
        return <Badge color="secondary">Send for edits</Badge>;
      case 3:
        return <Badge color="success">Accepted</Badge>;
      case 4:
        return <Badge color="danger">Rejected</Badge>;
      case 10:
        return <Badge color="info">Uploaded</Badge>;
      default:
        return <Badge color="warning">Unknown</Badge>;
    }
  };

  console.log('proReq', proReq);

  const renderStatusBadge2 = (status) => {
    switch (status) {
      case 1:
        return <Badge color="danger">Inactive</Badge>;
      case 2:
        return <Badge color="success">Active</Badge>;
      default:
        return <Badge color="danger">Inactive</Badge>;
    }
  };


  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };

  /*const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name_of_firm"],
      sortable: true,
      center: true,
    },
    {
      name: t("Pan Number"),
      selector: (Row) => Row["pan_number"],
      sortable: true,
      center: true,
    },
    {
      name: t("Type of Organization"),
      selector: (Row) => Row["type_of_organization"],
      sortable: true,
      center: true,
      minWidth: '200px', // Set a minimum width
      maxWidth: '600px', // Set a maximum width
      wrap: true, // Ensure text wraps within the cell
    },
    {
      name: t("Status"),
      selector: (Row) => renderStatusBadge(Row["status"]),
      sortable: true,
      center: true,
    },
    { name: t("Actions"), cell: ComponentEdit },
  ];*/

  const tableColumns = useMemo(() => [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name_of_firm"],
      sortable: true,
      center: true,
    },
    {
      name: t("Pan Number"),
      selector: (Row) => Row["pan_number"],
      sortable: true,
      center: true,
    },
    {
      name: t("Type of Organization"),
      selector: (Row) => Row["type_of_organization"],
      sortable: true,
      center: true,
      minWidth: '200px',
      maxWidth: '600px',
      wrap: true,
    },
    {
      name: t("Status"),
      selector: (Row) => renderStatusBadge(Row["status"]),
      sortable: true,
      center: true,
    },
    {
      name: t("Membership Status"),
      selector: (Row) => renderStatusBadge2(Row["membership_status"]),
      sortable: true,
      center: true,
    },
    { name: t("Actions"), cell: ComponentEdit },
  ], [t, ComponentEdit, renderStatusBadge]);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);


  const handle_payment_status = async (e) => {
    e.preventDefault();
    if(
      file !== ''
    ) {
    try {
      setLoading(true);
      let actualImage = null;

      if (file) {
        actualImage = await call_picture_upload(file);
      }

      const body = {
        payment_type: selectedOption === "renew-membership"? 2 :selectedOption === "provincial"? 4 : 1,
        firm_id: currentFirm,
      };

      if(selectedOption === "renew-membership") {
        body.payment_proof = actualImage;
        body.payment_proof_new = currentRow?.payment_proof_new;
        body.province_proof = currentRow?.province_proof;
        body.no_of_years = titleOption?.length;
      } else if(selectedOption === "provincial") {
        body.payment_proof_new = currentRow?.payment_proof_new;
        body.payment_proof = currentRow?.payment_proof;
        body.province_proof = actualImage;
      } else {
        body.payment_proof_new = actualImage;
        body.payment_proof = currentRow?.payment_proof;
        body.province_proof = currentRow?.province_proof;
      }

      const response2 = await axios.put(
        "https://api-portal.nada.org.np/api/firms/firm/payment",
        body,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        },
      );
      if (response2?.data?.success) {
        setLoading(false);
        toast.success(response2?.data?.message);
        toggle();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      console.log(error.response);
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  } else {
    toast.error("Payment Proof is required");
  }
  };


  const handle_payment_status_agm = async (e) => {
    e.preventDefault();
    if(
      file2 !== ''
    ) {
    try {
      setLoading2(true);
      let actualImage2 = null;
      if(file2) {
        actualImage2 = await call_picture_upload(file2);
      }

      const response2 = await axios.put(
        "https://api-portal.nada.org.np/api/firms/firm/payment",
        {
          firm_id: currentFirm,
          payment_proof_agm: actualImage2,
          payment_proof_new: currentRow?.payment_proof_new,
        payment_proof: currentRow?.payment_proof
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        },
      );
      if (response2?.data?.success) {
        setLoading2(false);
        toast.success(response2?.data?.message);
        toggle();
      }
    } catch (error) {
      setLoading2(false);
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  } else {
    toast.error("Payment Proof is required");
  }
  };


  const call_picture_upload = async (file) => {
    // 1. Get the Presigned URL
    const getUrl = await axios.get(
      `https://api-portal.nada.org.np/api/upload-url?filename=${file.name}&fileType=${file.type}`,
      {
        headers: {
             // Ensure you are sending auth if your backend requires it
            'Authorization': `Bearer ${token}`
        },
      }
    );

    const { uploadUrl, key } = getUrl.data;

    // 2. Upload to S3 (Crucial Fix Here)
    await axios.put(
      uploadUrl,
      file, // <--- Pass 'file' directly. Do NOT wrap in { body: file }
      {
        headers: {
            "Content-Type": file.type
        }
      }
    );

    return "https://d24xzirvx50zjt.cloudfront.net/" + key;
};


  const handleChange = (picked) => {
    if (!picked || picked.length === 0) {
      setSelectedTitleOption([]);
      return;
    }
    // find the highest‐index option that was just picked
    const pickedValues = picked.map((o) => o.value);
    const indices = titles
      .map((opt, i) => (pickedValues.includes(opt.value) ? i : -1))
      .filter((i) => i >= 0);
    const maxIdx = Math.max(...indices);

    // include everything from 0 up through that maxIdx
    setSelectedTitleOption(titles.slice(0, maxIdx + 1));
  };

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Firms")}</H5>
                <Btn
                  attrBtn={{ color: "primary", onClick: handleAddNewClick}}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                  }}
                >
                  {t("Add New")}
                </Btn>
              </CardHeader>
              <CardBody>
                {data &&
                <DataTable
                data={filteredItems}
                columns={tableColumns}
                striped={true}
                center={true}
                persistTableHead
                subHeader
                //selectableRows
                subHeaderComponent={subHeaderComponentMemo}
                paginationResetDefaultPage={resetPaginationToggle}
                contextActions={contextActions}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                pagination
                customStyles={customStyles}
              />
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
      isOpen={modal}
      //toggle={toggle}
      centered
      >
      <ModalHeader
      //toggle={toggle}
      >{t("Membership Payment Proof")}</ModalHeader>
      <ModalBody>

{(currentRow?.membership_status_new !== 2 || currentRow?.membership_status_new !== 2 || (proReq && currentRow?.province_status !== 2)) && <>
      <Label className="form-label" style={{ fontSize: 20 }}>{t("Payment Type")}</Label>
        <Row>
          <Col>
            {currentRow?.membership_status_new !== 2 && <><Label className="d-block" for="edo-ani">
              <Input
                className="radio_animated"
                id="edo-ani"
                type="radio"
                name="rdo-ani"
                value="new-membership"
                checked={selectedOption === "new-membership"}
                onChange={handleRadioChange}
              />
              {t("New Membership")}
            </Label></>}
            {currentRow?.membership_status !== 2 && <><Label className="d-block" for="edo-ani-2">
              <Input
                className="radio_animated"
                id="edo-ani-2"
                type="radio"
                name="rdo-ani"
                value="renew-membership"
                checked={selectedOption === "renew-membership"}
                onChange={handleRadioChange}
              />
              {t("Renew Membership")}
            </Label></>}
            {(proReq && currentRow?.province_status !== 2 )&&
            <Label className="d-block" for="edo-ani-2">
              <Input
                className="radio_animated"
                id="edo-ani-2"
                type="radio"
                name="rdo-ani"
                value="provincial"
                checked={selectedOption === "provincial"}
                onChange={handleRadioChange}
              />
              {t("Provincial Fees")}
            </Label>
                        }
            {selectedOption === "new-membership" && currentNew !== 0 && currentNew !== null?
                <div
                  style={{ display: 'flex', flexDirection: 'row', gap: 20 }}
                >
                  <Label className="form-label">{t("Price")}</Label>
                  <Label className="form-label">Rs {currentNew }</Label>
                </div>
              : selectedOption === "renew-membership" && currentRenew !== 0 && currentRenew !== null?
              <div
                style={{ display: 'flex', flexDirection: 'row', gap: 20 }}
              >
                <Label className="form-label">{t("Price")}</Label>
                <Label className="form-label">Rs {currentRenew}/{t("Year")}</Label>
              </div>
              : selectedOption === "provincial" && currentRenew !== 0 && currentRenew !== null?
              <div
                style={{ display: 'flex', flexDirection: 'row', gap: 20 }}
              >
                <Label className="form-label">{t("Price")}</Label>
                <Label className="form-label">Rs {proReqFees} </Label>
              </div>
              : null
            }
            {selectedOption === "renew-membership" &&
              <div
              style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
            >
              {/*<Label className="form-label">{t("Renew for Multiple Years")}</Label>
              <Input
                style={{ width: 150 }}
                type="number"
                placeholder="Enter number of years"
                value={noOfYears}
                onChange={(e) => setNoOfYears(e.target.value)}
              />*/}
              {
                currentRow?.pending_amt &&

              <div
                style={{ display: 'flex', flexDirection: 'row', gap: 20 }}
              >
                <Label className="form-label">{t("Pending Amt")}</Label>
                <Label className="form-label">Rs {currentRow?.pending_amt} </Label>
              </div>
}
                <Label className="col-form-label">{t("Select Fiscal Years")}</Label>
                <Select
                  options={titles}
                  value={titleOption}
                  onChange={handleChange}
                  className="js-example-basic-single col-sm-12"
                  isMulti
                />
            </div>
            }
          </Col>
        </Row>
        <Label className="form-label">{t("Upload Payment Proof")}</Label>
        <Dropzone1
              getUploadParams={getUploadParams3}
              //accept=".csv,text/csv"
              handleChangeStatus={handleChangeStatus3}
            />
          <div
            style={{ marginTop: 10 }}
          >
            {loading ? (
          <div className="loader-box">
            <Spinner attrSpinner={{ className: "loader-2" }} />
          </div>
        ) : (
          <Btn
            attrBtn={{
              color: "primary",
              onClick: handle_payment_status,
              outerHeight: 65,
            }}
          >
            {t("Update Payment Proof")}
          </Btn>
        )}
        </div>
        </>}

        {currentRow?.agm_status !== 2 && <>
        <Label className="form-label" style={{ fontsSize: 20, marginTop: 20 }}>{t("Annual General Meeting Fees(AGM)")}</Label>
        <Row>
          <Col>
            {currentAGM !== 0 && currentAGM !== null?
                <div
                  style={{ display: 'flex', flexDirection: 'row', gap: 20 }}
                >
                  <Label className="form-label">{t("Price")}</Label>
                  <Label className="form-label">Rs {currentAGM }/{t("Year")}</Label>
                </div>
              : null
            }
          </Col>
        </Row>
        <Label className="form-label">{t("Upload Payment Proof")}</Label>
        <Dropzone1
              getUploadParams={getUploadParams4}
              //accept=".csv,text/csv"
              handleChangeStatus={handleChangeStatus4}
            />
               <div
            style={{ marginTop: 10 }}
          >
            {loading2 ? (
          <div className="loader-box">
            <Spinner attrSpinner={{ className: "loader-2" }} />
          </div>
        ) : (
          <Btn
            attrBtn={{
              color: "primary",
              onClick: handle_payment_status_agm,
              outerHeight: 65,
            }}
          >
            {t("Update AGM Payment Proof")}
          </Btn>
        )}
        </div>
            </>}
            <div
            style={{ display: 'flex', flexDirection: 'column', marginTop: 10, gap: 10 }}
            >
            <Label className="form-label" style={{ fontSize: 20 }}>{t("Payment QR")}</Label>
            <Image attrImage={{ className: 'img-fluid', src: `${qr}`, alt: '' }} />
            </div>
      </ModalBody>
      <ModalFooter>
        <div
          onClick={() => toggle(currentFirm)}
        >
          <Btn attrBtn={{ color: "secondary", height: 65 }}>
            {t("Close")}
          </Btn>
        </div>
        {/*loading ? (
          <div className="loader-box">
            <Spinner attrSpinner={{ className: "loader-2" }} />
          </div>
        ) : (
          <Btn
            attrBtn={{
              color: "primary",
              onClick: handle_payment_status,
              outerHeight: 65,
            }}
          >
            {t("Update Payment Proof")}
          </Btn>
        )*/}
      </ModalFooter>
    </Modal>
    </Fragment>
  );
};
export default DataTablesContain;
